var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15032 20H16.8496C18.7865 20 19.5924 17.5218 18.0259 16.3825L17.1769 15.7651C16.4932 15.2678 15.6696 15 14.8242 15H9.17569C8.33032 15 7.50668 15.2678 6.823 15.7651L5.97398 16.3825C4.40749 17.5218 5.21336 20 7.15032 20Z",
    fill: "#D92D26",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17575 15.85C8.51002 15.85 7.86141 16.0609 7.32301 16.4525L6.47399 17.0699C5.57326 17.725 6.03664 19.15 7.15039 19.15H16.8497C17.9634 19.15 18.4268 17.725 17.526 17.0699L16.677 16.4525C16.1386 16.0609 15.49 15.85 14.8243 15.85H9.17575ZM6.32312 15.0776C7.15208 14.4747 8.15074 14.15 9.17575 14.15H14.8243C15.8493 14.15 16.848 14.4747 17.6769 15.0776L17.177 15.765L17.6769 15.0776L18.5259 15.6951C20.7582 17.3185 19.6098 20.85 16.8497 20.85H7.15039C4.39022 20.85 3.24185 17.3185 5.4741 15.6951L6.32312 15.0776Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z",
    fill: "#D92D26",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 4.84999C10.2602 4.84999 8.8499 6.2603 8.8499 7.99999C8.8499 9.73969 10.2602 11.15 11.9999 11.15C13.7396 11.15 15.1499 9.73969 15.1499 7.99999C15.1499 6.2603 13.7396 4.84999 11.9999 4.84999ZM7.1499 7.99999C7.1499 5.32141 9.32132 3.14999 11.9999 3.14999C14.6785 3.14999 16.8499 5.32141 16.8499 7.99999C16.8499 10.6786 14.6785 12.85 11.9999 12.85C9.32132 12.85 7.1499 10.6786 7.1499 7.99999Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.40f9957cdd259bd7e3bf921a8015a63a.svg";
export { ForwardRef as ReactComponent };